<style lang="scss" scoped>
.school {
	&__status {
		.el-alert {
			margin-bottom: 10px;
			color: #fff;
			&:last-child {
				margin-bottom: 20px;
			}
		}
		&--offline {
			background-color: #da3b3b;
		}
		&--demo {
			background-color: #4c85ff;
		}
		&--disabled {
			background-color: #2f363f;
		}
		&--pending {
			background-color: #5c7de3;
		}
	}
}
</style>
<template lang="pug">
	page(v-loading="$apollo.loading").school
		.school__status(v-if="this.School && this.companyIsPendingForSchool && this.companyIsAuthoriseByEnterpriseForSchool == ''")
			el-alert(title='Pending Approval.', type='info', effect="dark", :closable="false", show-icon, v-if="School && companyIsPendingForSchool").school__status--pending
		.school__status(v-if="this.School && this.companyIsPendingForSchool && this.companyIsAuthoriseByEnterpriseForSchool")
			el-alert(:title='companyIsAuthoriseByEnterpriseForSchool', type='info', effect="dark", :closable="false", show-icon, v-if="School && companyIsPendingForSchool && companyIsAuthoriseByEnterpriseForSchool").school__status--pending
		.school__status(v-if="this.School && this.companyIsApprovedForSchool")
			el-alert(title='Demo School.', type='info', effect="dark", :closable="false", show-icon, v-if="School.demo").school__status--demo
			el-alert(title='School is currently disabled.', type='info', effect="dark", :closable="false", show-icon, v-if="!School.Settings.is_active").school__status--disabled
			el-alert(:title='`School is currently offline${lastSeen}`', type='error', effect="dark", :closable="false", show-icon, v-if="!School.online").school__status--offline
		el-row(:gutter="30", v-if="!$apollo.loading")
			el-col(:span="12")
				details-panel(:school="School")
			el-col(:span="12", v-if="School && companyIsPendingForSchool")
				pending-details-panel(:school="School")
			el-col(:span="12", v-if="School && companyIsApprovedForSchool")
				advanced-details-panel(:school="School")
		data-statistics(:school="School", v-if="School && companyIsApprovedForSchool").school__statistics
		reports(v-can:view-reports, :school="School", v-if="School && companyIsApprovedForSchool")
		referral-respond(:referral="referralCase", v-if="School && referralCase && companyIsPendingForSchool")
		referral-events(:referralIds="referralCaseIds", v-if="School && referralCaseIds && companyIsPendingForSchool")
</template>

<script>
import DetailsPanel from "./includes/DetailsPanel";
import AdvancedDetailsPanel from "./includes/AdvancedDetailsPanel";
import PendingDetailsPanel from "./includes/PendingDetailsPanel";
import DataStatistics from "./includes/DataStatistics";
import Reports from "./includes/Reports";
import SchoolQuery from "@/graphql/queries/School";
import ReferralRespond from "@/views/referral/includes/ReferralRespond";
import ReferralEvents from "@/views/referral/includes/ReferralEvents";
import gql from "graphql-tag";
import moment from "moment";

export default {
	name: "Details",
	data() {
		return {
			lastSeen: null,
			referralCase: null,
			referralCaseIds: null
		}
	},
	components: {
		DataStatistics,
		AdvancedDetailsPanel,
		PendingDetailsPanel,
		DetailsPanel,
		Reports,
		ReferralRespond,
		ReferralEvents
	},

	computed: {
		companyIsApprovedForSchool() {
			return this.School.State.map(state => state.state).includes("approved");
		},
		companyIsPendingForSchool() {
			return this.School.State.map(state => state.state).includes("pending");
		},
		companyIsAuthoriseByEnterpriseForSchool() {
			const notAllowedStates = this.School.State.filter(state => state.enterprise_state != '' && state.state === 'pending');
			const notAllowedCompanies = notAllowedStates.length > 1 ? (notAllowedStates.map(state => state.Company.name).join(', ') + ': ') : '';

			return notAllowedStates.length == 0 ? '' : notAllowedCompanies  + notAllowedStates.map(state => state.enterprise_state)[0];
		}
	},
	apollo: {
		School: {
			query: SchoolQuery,
			variables() {
				return {
					id: this.$route.params.school
				};
			},
			result(result) {
				if (result.data.School) {
					this.$bus.emit("school-viewed", result.data.School);
					this.lastSeen = result.data.School.last_heartbeat_at
						? `, last seen ${moment(result.data.School.last_heartbeat_at).fromNow()}.`
						: '.';
				}
			}
		},
		Referrals: {
			query: gql`
				query Referrals($school: String) {
					Referrals(school: $school) {
						id
						created_at
						School {
							id
							name
							establishment_number
							la_code
							urn
							Mis {
								nice_name
							}
						}
						Company {
							name
						}
						state
						status
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					school: this.$route.params.school
				};
			},
			result(result) {		
				if (result.data != undefined && result.data.Referrals) {
					this.referralCase = !result.data.Referrals.length ? false: result.data.Referrals[0];
					this.referralCaseIds = !result.data.Referrals.length ? false: result.data.Referrals.map(c => c.id).join(",");
				}
			}
		}
	}
};
</script>
